import { z } from 'zod';
import { EventListItemDto } from './event';
import { ConnectionCardStatsDto } from './public-card';

export const MeHomeTasksDto = z.object({
  /** Встречи, где я приглашён и ещё не ответил (attendance INVITED, будущие). */
  meetings: z.number().int(),
  /** Переписки с непрочитанными — то же правило, что у бейджа на вкладке «Встречи». */
  unreadChats: z.number().int(),
  /** PENDING-заявки на запись к моим событиям (я организатор). */
  rsvpRequests: z.number().int(),
});
export type MeHomeTasksDto = z.infer<typeof MeHomeTasksDto>;

export const MeHomeUpcomingDto = z.object({
  /** Всего впереди — не длина `items`. */
  count: z.number().int(),
  /** Первые записи по возрастанию startsAt (не больше HOME_UPCOMING_LIMIT). */
  items: z.array(EventListItemDto),
});
export type MeHomeUpcomingDto = z.infer<typeof MeHomeUpcomingDto>;

export const MeHomeRecommendedDto = z.object({
  items: z.array(EventListItemDto),
});
export type MeHomeRecommendedDto = z.infer<typeof MeHomeRecommendedDto>;

export const MeHomeResponseDto = z.object({
  /** Уникальные люди: карточки соцграфа ∪ мэтчи ∪ собеседники DIRECT-чатов. */
  contacts: z.number().int(),
  /**
   * Числа оборота Connection Card одним блоком — теми же определениями, что на
   * публичной визитке (`PublicCardStatsDto`), чтобы владелец и гость видели
   * одно и то же число. Отдельных запросов под них экран «Я» не делает.
   */
  connectionCard: ConnectionCardStatsDto,
  /** = totalCount из /me/favorites (тот же счётчик, что на сердечке в шапке). */
  likes: z.number().int(),
  upcoming: MeHomeUpcomingDto,
  /** Персональная подборка на стартовом экране «Я» (issue #175). */
  recommended: MeHomeRecommendedDto,
  tasks: MeHomeTasksDto,
});
export type MeHomeResponseDto = z.infer<typeof MeHomeResponseDto>;
